<template>
  <CCard>
    <CCardHeader class="border-0 px-4 pb-1 pt-4">
      <div class="d-flex align-items-center font-weight-medium">
        <CIcon name="cipGridSm" size="custom-size" :width="18" class="mr-2"/>
        <translate translate-context="chargeback.detail">Movimenti contabili</translate>
        <CButton
          color="link"
          size="sm"
          class="ml-2 p-0"
          @click="$emit('open-explanation')"
          v-c-tooltip="{content: $pgettext('chargeback.detail', 'How is the chargeback calculated?'), placement: 'top'}"
        >
          <CIcon name="cipInfo" size="sm"/>
        </CButton>
      </div>
    </CCardHeader>
    <CCardBody>
      <div v-if="groups.length === 0" class="text-center py-4">
        <CIcon name="cipXCircle" size="xl" class="mb-2"/>
        <p class="mb-0">
          <translate translate-context="chargeback.detail">No ledger entries found</translate>
        </p>
      </div>
      <div
        v-for="(group, idx) in groups"
        :key="group.key"
        class="ledger-group"
        :class="{ 'mt-4': idx > 0 }"
      >
        <div class="ledger-group__header">
          <template v-if="group.type === 'order_item'">
            <span class="font-weight-medium mr-2">{{ group.label }}</span>
            <code v-if="group.picacode" class="picacode-tag mr-2">
              <CIcon name="cil-qr-code" size="sm" class="mr-1"/>{{ group.picacode }}
            </code>
            <span v-if="group.itemId" class="text-muted small">#{{ group.itemId }}</span>
          </template>
          <template v-else>
            <CIcon name="cipCoin" size="sm" class="mr-2"/>
            <span class="font-weight-medium">
              <translate translate-context="chargeback.detail">Handling fee</translate>
            </span>
          </template>
        </div>
        <LedgerEntriesTable :entries="group.entries" bare/>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import LedgerEntriesTable from '../../components/LedgerEntriesTable.vue'
import {sortEntriesByStakeholder} from '../../constants'

function normalizeEntry(entry) {
  return {
    ...entry,
    currency: entry.currency || 'EUR'
  }
}

export default {
  name: 'ChargebackLedgerEntries',
  components: {LedgerEntriesTable},
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  computed: {
    groups() {
      const entries = (this.record.entries || []).map(normalizeEntry)
      const byKey = new Map()
      const encounter = []

      for (const entry of entries) {
        const type = entry.source_type || 'order_item'
        const id = entry.source_id != null ? entry.source_id : type
        const key = `${type}:${id}`
        if (!byKey.has(key)) {
          byKey.set(key, {key, type, id, entries: []})
          encounter.push(key)
        }
        byKey.get(key).entries.push(entry)
      }

      const orderItemKeys = encounter.filter(k => byKey.get(k).type === 'order_item')
      const handlingFeeKeys = encounter.filter(k => byKey.get(k).type === 'handling_fee')
      const currentItemId = this.record.source_type === 'order_item' ? this.record.order_item_id : null

      return [...orderItemKeys, ...handlingFeeKeys].map(k => {
        const g = byKey.get(k)
        const base = {
          key: g.key,
          type: g.type,
          entries: sortEntriesByStakeholder(g.entries)
        }
        if (g.type !== 'order_item') return base
        const isCurrent = currentItemId != null && g.id === currentItemId
        return {
          ...base,
          itemId: g.id,
          label: isCurrent
            ? (this.record.pica_service_name || `Order item #${g.id}`)
            : `Order item #${g.id}`,
          picacode: isCurrent ? (this.record.picacode || this.record.context?.picacode || null) : null
        }
      })
    }
  }
}
</script>

<style scoped>
.ledger-group__header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 8px 0;
  margin-bottom: 6px;
  border-bottom: 1px solid #e4e7ea;
}

.picacode-tag {
  background: #f4f6f9;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.8rem;
}
</style>
